<template>
  <div class="swiper-container gameBox">
    <div class="swiper-wrapper">
      <div class="swiper-slide backcolor">
        <img src="../assets/expertimg/back-1.png" class="">
        <div class="gameBox-1 ani" swiper-animate-effect="animate__bounceInLeft" swiper-animate-duration="1s" swiper-animate-delay="0"><img src="../assets/expertimg/back-1-1.png"></div>
        <div class="gameBox-2 ani" swiper-animate-effect="animate__bounceInLeft" swiper-animate-duration="2s" swiper-animate-delay="0"><img src="../assets/expertimg/back-1-2.png"></div>
        <div class="gameBox-3 ani" swiper-animate-effect="animate__bounceInLeft" swiper-animate-duration="3s" swiper-animate-delay="0"><img src="../assets/expertimg/back-1-3.png"></div>
        <div class="gameBox-4 ani" swiper-animate-effect="animate__backInUp" swiper-animate-duration="1s" swiper-animate-delay="0" @click="next"><img src="../assets/expertimg/down.png"></div>
      </div>
      <div class="swiper-slide">
        <img class="backimg" src="../assets/expertimg/back-3.png">
        <div class="gameBox-8 ani" swiper-animate-effect="animate__fadeInDown" swiper-animate-duration="1s" swiper-animate-delay="0"><img src="../assets/expertimg/back-3-1.png"></div>
        <div class="gameBox-9 ani" swiper-animate-effect="animate__fadeInUp" swiper-animate-duration="1s" swiper-animate-delay="0"><img src="../assets/expertimg/back-3-2.png"></div>
        <div class="gameBox-15 ani" swiper-animate-effect="animate__fadeInUp" swiper-animate-duration="1s" swiper-animate-delay="0"><img src="../assets/expertimg/back-3-3.png"></div>
        <div class="gameBox-16 ani" swiper-animate-effect="animate__fadeInUp" swiper-animate-duration="1s" swiper-animate-delay="0"><img src="../assets/expertimg/back-3-4.png"></div>
        <div class="gameBox-17 ani" swiper-animate-effect="animate__fadeInUp" swiper-animate-duration="1s" swiper-animate-delay="0"><img src="../assets/expertimg/back-3-5.png"></div>
        <div class="gameBox-4 ani" swiper-animate-effect="animate__backInUp" swiper-animate-duration="1s" swiper-animate-delay="0" @click="next"><img src="../assets/expertimg/down.png"></div>
      </div>
      <div class="swiper-slide">
        <img class="backimg" src="../assets/expertimg/back-3.png">
        <div class="gameBox-8 ani" swiper-animate-effect="animate__fadeInDown" swiper-animate-duration="1s" swiper-animate-delay="0"><img src="../assets/expertimg/back-4-1.png"></div>
        <div class="gameBox-10 ani" swiper-animate-effect="animate__fadeInUp" swiper-animate-duration="1s" swiper-animate-delay="0"><img src="../assets/expertimg/back-4-2.png"></div>
        <div class="gameBox-4 ani" swiper-animate-effect="animate__backInUp" swiper-animate-duration="1s" swiper-animate-delay="0" @click="next"><img src="../assets/expertimg/down.png"></div>
      </div>
      <div class="swiper-slide">
        <img class="backimg" src="../assets/expertimg/back-5.png">
        <div class="gameBox-8 ani" swiper-animate-effect="animate__fadeInDown" swiper-animate-duration="1s" swiper-animate-delay="0"><img src="../assets/expertimg/back-5-1.png"></div>
        <div class="gameBox-10 ani" swiper-animate-effect="animate__fadeInUp" swiper-animate-duration="1s" swiper-animate-delay="0"><img src="../assets/expertimg/back-5-2.png"></div>
        <div class="gameBox-4 ani" swiper-animate-effect="animate__backInUp" swiper-animate-duration="1s" swiper-animate-delay="0" @click="next"><img src="../assets/expertimg/down.png"></div>
      </div>
      <!-- <div class="swiper-slide">
        <img class="backimg" src="../assets/expertimg/back-5.png">
        <div class="gameBox-8 ani" swiper-animate-effect="animate__fadeInDown" swiper-animate-duration="1s" swiper-animate-delay="0"><img src="../assets/expertimg/back-6-1.png"></div>
        <div class="gameBox-12 ani" swiper-animate-effect="animate__slideInLeft" swiper-animate-duration="1s" swiper-animate-delay="0"><img src="../assets/expertimg/back-6-2.png"></div>
        <div class="gameBox-4 ani" swiper-animate-effect="animate__backInUp" swiper-animate-duration="1s" swiper-animate-delay="0" @click="next"><img src="../assets/expertimg/down.png"></div>
      </div> -->
      <div class="swiper-slide">
        <img class="backimg" src="../assets/expertimg/back-3.png">
        <div class="gameBox-8 ani" swiper-animate-effect="animate__fadeInDown" swiper-animate-duration="1s" swiper-animate-delay="0"><img src="../assets/expertimg/back-7-1.png"></div>
        <div class="gameBox-10 ani" swiper-animate-effect="animate__fadeInUp" swiper-animate-duration="1s" swiper-animate-delay="0"><img src="../assets/expertimg/back-7-2.png"></div>
        <div class="gameBox-4 ani" swiper-animate-effect="animate__backInUp" swiper-animate-duration="1s" swiper-animate-delay="0" @click="next"><img src="../assets/expertimg/down.png"></div>
      </div>
      <!-- <div class="swiper-slide">
        <img class="backimg" src="../assets/expertimg/back-4.png">
        <div class="gameBox-8 ani" swiper-animate-effect="animate__fadeInDown" swiper-animate-duration="1s" swiper-animate-delay="0"><img src="../assets/expertimg/back-8-1.png"></div>
        <div class="gameBox-10 ani" swiper-animate-effect="animate__fadeInUp" swiper-animate-duration="1s" swiper-animate-delay="0"><img src="../assets/expertimg/back-8-2.png"></div>
        <div class="gameBox-4 ani" swiper-animate-effect="animate__backInUp" swiper-animate-duration="1s" swiper-animate-delay="0" @click="next"><img src="../assets/expertimg/down.png"></div>
      </div> -->
      <div class="swiper-slide">
        <img class="backimg" src="../assets/expertimg/back-3.png">
        <div class="gameBox-8 ani" swiper-animate-effect="animate__fadeInDown" swiper-animate-duration="1s" swiper-animate-delay="0"><img src="../assets/expertimg/back-9-1.png"></div>
        <div class="gameBox-12 ani" swiper-animate-effect="animate__slideInLeft" swiper-animate-duration="1s" swiper-animate-delay="0"><img src="../assets/expertimg/back-9-2.png"></div>
        <div class="gameBox-4 ani" swiper-animate-effect="animate__backInUp" swiper-animate-duration="1s" swiper-animate-delay="0" @click="next"><img src="../assets/expertimg/down.png"></div>
      </div>
      <div class="swiper-slide">
        <img class="backimg" src="../assets/expertimg/back-5.png">
        <div class="gameBox-8 ani" swiper-animate-effect="animate__fadeInDown" swiper-animate-duration="1s" swiper-animate-delay="0"><img src="../assets/expertimg/back-2-1.png"></div>
        <div class="gameBox-5 ani" swiper-animate-effect="animate__bounceInLeft" swiper-animate-duration="1s" swiper-animate-delay="0"><img src="../assets/expertimg/back-2-2.png"></div>
        <div class="gameBox-6 ani" swiper-animate-effect="animate__bounceInLeft" swiper-animate-duration="1s" swiper-animate-delay="0"><img src="../assets/expertimg/back-2-3.png"></div>
        <div class="gameBox-7 ani" swiper-animate-effect="animate__bounceInLeft" swiper-animate-duration="1s" swiper-animate-delay="0"><img src="../assets/expertimg/back-2-4.png"></div>
        <div class="gameBox-11 ani" swiper-animate-effect="animate__bounceInLeft" swiper-animate-duration="1s" swiper-animate-delay="0"><img src="../assets/expertimg/back-2-6.png"></div>
        <!-- <div class="gameBox-app ani" swiper-animate-effect="animate__backInUp" swiper-animate-duration="1s" swiper-animate-delay="0" @click="appDow">
          <img src="../assets/expertimg/back-2-5.png">
        </div> -->
        <div class="gameBox-app ani" swiper-animate-effect="animate__backInUp" swiper-animate-duration="1s" swiper-animate-delay="0">
          <img src="../assets/expertimg/back-2-5.png" @click="registerDialog = true">
        </div>
        <div class="gameBox-4 ani" swiper-animate-effect="animate__backInUp" swiper-animate-duration="1s" swiper-animate-delay="0" @click="next"><img src="../assets/expertimg/down.png"></div>
      </div>
      <div class="swiper-slide">
        <img class="backimg" src="../assets/expertimg/back-3.png">
        <div class="gameBox-8 ani" swiper-animate-effect="animate__fadeInDown" swiper-animate-duration="1s" swiper-animate-delay="0"><img src="../assets/expertimg/back-10-1.png"></div>
        <div class="gameBox-14 ani" swiper-animate-effect="animate__lightSpeedInRight" swiper-animate-duration="1s" swiper-animate-delay="0"><img src="../assets/expertimg/back-10-2.png"></div>
        <div class="gameBox-wx ani" swiper-animate-effect="animate__backInUp" swiper-animate-duration="1s" swiper-animate-delay="0" @click="share"><img src="../assets/expertimg/back-10-3.png"></div>
      </div>
    </div>
    <van-overlay :show="registerDialog" @click="registerDialog = false">
      <div class="register_wrapper" @click.stop>
        <div class="register_block">
          <van-form style="width: 100%;">
            <div class="register_block-item">
                <van-field v-model="introMobile" name="introMobile" type="tel" maxlength="11" placeholder="请输入您的手机号"/>
            </div>
            <div class="register_block-item">
                <van-field v-model="introCode" name="introCode" type="digit" maxlength="6" placeholder="请输入验证码"/>
                <button class="sendCode" :style="{'color':codeStatus ? '#999999':'','background-color':codeStatus ?'#f7f7f7':''}" :disabled="codeStatus" @click="sendCode">{{codeText}}</button>
            </div>
            <div class="submit-btn">
              <van-button round block @click="onSubmitIntro">立即入驻</van-button>
            </div>
          </van-form>
          <img src="../assets/expertimg/close.png" class="close-btn-1" @click="registerDialog = false"/>
        </div>
      </div>
    </van-overlay>
    <van-overlay :show="openPopup1" @click="openPopup1 = false">
      <div class="wrapper" @click.stop>
        <div class="block">
          <div class="msgbox">
            <h3>专家招募</h3>
            <p>该专家招募请下载最新版中科名兽医APP</p>
            <div class="msgbox-botton" v-if="openPopup == true">
              <span>打开中科名兽医APP</span>
              <wx-open-launch-app class="launch-btn" :id="id" :appid="appid" :extinfo="wechatOpenAppData">
                <script type="text/wxtag-template">
                  <style>.btn {height: 45px;}</style>
                  <div class="btn">打开APP</div>
                </script>
              </wx-open-launch-app>
            </div>
            <div class="openapp-button" v-else @click="openApp"><img src="../assets/liveimg/openapp-small.svg"></div>
          </div>
          <div class="old-close" @click="openPopup1 = false"><img src="../assets/liveimg/close.svg"></div>
        </div>
      </div>
    </van-overlay>
    <van-overlay :show="openWx" @click="openWx = false">
      <div class="wrapper" @click="openWx = false">
        <div class="wx-back">
          <img src="../assets/expertimg/wx.png">
        </div>
      </div>
    </van-overlay>
  </div>
  
</template>

<script>
  var mySwiper
  import * as swiperAni from '../assets/expertimg/swiper.animate.js'
  import Swiper from '../assets/expertimg/swiper.js'
  import '../assets/expertimg/swiper.css'
  import { iswx,wxshare } from '@/utils/utils.js'
  import * as  API_ from '@/api/resetApi.js'
  import { Notify, Toast } from 'vant';
  export default {
    name: 'Expertrecruitment',
    components: {
        [Notify.Component.name]: Notify.Component,
    },
    data() {
      return {
        height: document.documentElement.clientHeight,
        width: document.documentElement.clientWidth,
        img: 'https://zkjy.oss-cn-beijing.aliyuncs.com/2021/share/expertshare.png',
        title: '中科名兽医，专家招募活动开始啦！',
        desc: '诚挚邀请您加入名兽医团队，共同打造互联网兽医平台。',
        openPopup1: false,
        openWx: false,
        openPopup: false,
        id: 'wxopenLanchAppId',
        appid: 'wxdc89dd9a7329fe47',
        wechatOpenAppData: '',
        registerDialog:false,

        // 注册
        introMobile:'',
        introCode:'',
        submitStatus:false,
        codeText:'获取验证码',
        countDown: 60,
        codeStatus:false,
        timer:null,
        token:''
      }
    },
    created(){
      // console.log('this.getApp',this.getApp)
      wxshare(this.img,this.title,this.desc);
      let json = {
        "type": "summon",
        "linkId": ''
      }
      this.wechatOpenAppData = JSON.stringify(json)
      if (iswx() === true) {
        let wechat = navigator.userAgent.match(/MicroMessenger\/([\d\.]+)/i);
        // console.log('wechat',wechat)
        let judgewechat = wechat[1].split('.')
        // this.text = judgewechat
        if (judgewechat[0]>=8) {
          this.openPopup = true
        } else if(judgewechat[0]>=7){
          if(judgewechat[1]>=0){
              this.text = judgewechat
            if(judgewechat[2]>=12){
              this.openPopup = true
              console.log("当前符合 h5 打开指定app")                    
            }
          }
        }
      }
    },
    mounted() {
      // console.log('height',this.height)
      this.getApp = this.$route.query.h5
      if (this.getApp == 'android') {
        this.height = Number(document.documentElement.clientHeight) + 10
      }
      // console.log('this.getApp111',this.getApp)
      // console.log('height111',this.height)
      this.$nextTick(function () {
        mySwiper = new Swiper ('.swiper-container', {
          height: this.height,
          width: document.documentElement.clientWidth,
          // 设定初始化时slide的索引
          initialSlide: 0,
          //Slides的滑动方向，可设置水平(horizontal)或垂直(vertical)
          direction: 'vertical',
          followFinger : false,
          resistanceRatio : 0,
          // 环状轮播
          loop: false,
          // 一个屏幕展示的数量
          slidesPerView: 1,
          // 修改swiper自己或子元素时，自动初始化swiper
          observer: true,
          // 修改swiper的父元素时，自动初始化swiper
          observeParents: true,
          lazy: {
            loadPrevNext: true,
          },
          on: {
            init: function(){
              swiperAni.swiperAnimate(this); //初始化完成开始动画
            },
            touchMove: function(swiper,event){
              // console.log('11111')
              event.preventDefault()//你的事件
              // console.log('22222')
            },
            slideChangeTransitionEnd: function(){
              swiperAni.swiperAnimateCache(this); //隐藏动画元素 
              swiperAni.swiperAnimate(this);
            },
          },
        })
      })
      if (this.openPopup == true) {
        var btn = document.getElementById(this.id)
        btn.addEventListener('launch', e => {
          console.log('success');
        });
        btn.addEventListener('error',  e => {
          this.text = e.detail.errMsg
          if (e.detail.errMsg == 'launch:fail') {
            window.location = 'http://t.cn/Aijv8II4'
          } else {
            this.$createToast({
              txt: e.detail,
              type: 'error'
            }).show()
          }
        });
      }   
    },
    methods: {
      next() {
        mySwiper.slideNext();
      },
      openApp() {
        window.location = 'http://t.cn/Aijv8II4'
      },
      appDow() {
        if (this.getApp == 'ios') {
          window.webkit.messageHandlers.goExpertReg.postMessage({name: 'zhangyutang', age: 12});
        } else if (this.getApp == 'android') {
          ZKAPP.goExpertReg();
        } else {
          this.openPopup1 = true
        }
      },
      share() {
        if (this.getApp == 'ios') {
          window.webkit.messageHandlers.goShare.postMessage({name: 'zhangyutang', age: 12});
        } else if (this.getApp == 'android') {
          ZKAPP.goShare();
        } else {
          this.openWx = true
        }
      },
      countDowns(){
        this.timer = setInterval(()=>{
          this.countDown --
          if(this.countDown<0){
            clearInterval(this.timer);
            this.countDown = 60
            this.codeText = '重新发送'
            this.codeStatus = false
          }else{
            this.codeStatus = true
            this.codeText = this.countDown+'s'
          }
        },1000)
      },
      async sendCode(){
        const re = /^1(3|4|5|6|7|8|9)\d{9}$/
        if(!this.introMobile){
            return Toast('手机号不能为空')
        } else if(!re.test(this.introMobile)){
            return Toast('请填写正确的手机格式')
        }else{
            this.countDowns()
            const data = {
                cuPhone:this.introMobile,
                sysCode:'zkmsy',
                cpmType: 1
            }
            try {
                const res = await API_.getSmsCode(data)
                if(res.data.code == 200){
                    Toast.success('发送成功')
                }else if(res.data.code == 0){
                    Toast(res.data.msg)
                    clearInterval(this.timer);
                    this.countDown = 60
                    this.codeStatus = true
                }else{
                    Toast('发送失败')
                    clearInterval(this.timer);
                    this.countDown = 60
                    this.codeText = '重新发送'
                    this.codeStatus = false
                }
            } catch (error) {
                
            }
        }
        
      },
      onSubmitIntro(values){
        const re = /^1(3|4|5|6|7|8|9)\d{9}$/
        if(!this.introMobile){
          return Toast('手机号不能为空')
        } else if(!re.test(this.introMobile)){
          return Toast('请填写正确的手机格式')
        }else if(!this.introCode){
          return Toast('验证码不能为空')
        } else{
          this.login()
        }
      },
      // 获取登录信息
      async tokenlogin(token) {
        let data = {
          syscode: 'zkmsy',
          utoken: token,
          accessPort: 'h5',
          reg_form: 'applet'
        }
        const res = await API_.tokenlogin(data)
        try {
          if (res.data.code == 1) {
            this.submitStatus = true
            localStorage.setItem('eToken', res.data.obj[0].token)
            localStorage.setItem('userId', res.data.obj[0].user_id)
            this.$store.state.report.expertToken = res.data.obj[0].token
            this.$store.state.report.expertUserName = res.data.obj[0].user_name
            this.$store.state.report.expertUserId = res.data.obj[0].user_id
            Toast.success('入驻成功')
            this.$router.push({
              name:'identification',
              query:{
                user_id:res.data.obj[0].user_id
              }
            })
          } else {
            Toast.fail(res.data.msg);
          }
        } catch (error) {}
      },
      async login(){
        const data = {
          cuPhone: this.introMobile,
          msgCode: this.introCode
        }
        try {
          const res = await API_.getZkmsyPhonelogin(data)
          if(res.data.code == 200){
              this.token = res.data.data
              this.tokenlogin(res.data.data)
          }else{
              Toast('入驻失败')
          }
        } catch (error) {
            
        }
      },
    },
  }
</script>

<style lang="scss">
  .register_wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

  .register_block {
    padding: 0 4.07vw;
    width: 75.56vw;
    height: 50.56vw;
    background: #ffffff;
    border-radius:2.22vw;
    .close-btn-1{
      width: 7.04vw;
      height: 7.04vw;
    }
    .register_block-item{
      display: flex;
      height: 15vw;
      align-items: center;
      opacity: 1;
      border-bottom: 0.27vw solid #f5f5f5;
      .sendCode{
          width: 28vw;
          height: 8vw;
          opacity: 1;
          background: #0186ff;
          border-radius: 1.07vw;
          font-size: 3.2vw;
          font-family: PingFangSC, PingFangSC-Regular;
          font-weight: 400;
          text-align: center;
          color: #ffffff;
          line-height: 8vw;
          padding: 0;
          margin: 0;
      }
      .van-cell{
        padding: 0;
      }
      .van-cell::after{
          border: none;
      }
    }
    .submit-btn{
      padding-top: 4.07vw;
      button{
        width:55.37vw;
        height: 11.73vw;
        background: linear-gradient(315deg,#096fcb, #2784f8);
        border-radius: 5.87vw;
        backdrop-filter: blur(10px);
        font-size: 4.8vw;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        text-align: center;
        color: #ffffff;
        line-height: 11.73vw;
        margin: 0 auto;
      }
      
    }
  }
  .gameBox {
    // max-width: 768px;
    // margin: 0 auto;
    height: 100vh;
    overflow: hidden;
    .duration {
      animation-duration: 2s; /* don't forget to set a duration! */
    }
    .backcolor {
      background: #127BE4;
      img {
        max-width: 100%;
        height: 100%;
      }
    }
    .backimg {
      width: 100%;
      height: 100%;
    }
    .gameBox-1 {
      position: absolute;
      bottom: 50%;
      left: 50%;
      margin-left: -170px;
      margin-bottom: -32.5px;
      img {
        width: 340px;
        height: 65px;
      }
    }
    .gameBox-2 {
      position: absolute;
      bottom: 36%;
      left: 50%;
      margin-left: -170px;
      margin-bottom: -37px;
      img {
        width: 340px;
        height: 74px;
      }
    }
    .gameBox-3 {
      position: absolute;
      bottom: 21.5%;
      left: 50%;
      margin-left: -170px;
      margin-bottom: -37px;
      img {
        width: 340px;
        height: 74px;
      }
    }
    .gameBox-4 {
      position: absolute;
      font-size: 0;
      bottom: 7%;
      left: 50%;
      margin-left: -22px;
      margin-bottom: -22px;
      z-index: 999;
      img {
        width: 44px;
        height: 44px;
      }
    }
    .gameBox-8 {
      position: absolute;
      top: 6%;
      left: 50%;
      margin-left: -160px;
      margin-bottom: -30px;
      img {
        width: 320px;
        height: 60px;
      }
    }
    .gameBox-9 {
      position: absolute;
      top: 20%;
      left: 50%;
      margin-left: -150px;
      margin-bottom: -30px;
      img {
        width: 300px;
        height: 60px;
      }
    }
    .gameBox-15 {
      position: absolute;
      top: 32%;
      left: 50%;
      margin-left: -150px;
      margin-bottom: -22px;
      img {
        width: 300px;
        height: 44px;
      }
    }
    .gameBox-16 {
      position: absolute;
      top: 44%;
      left: 50%;
      margin-left: -150px;
      margin-bottom: -21px;
      img {
        width: 300px;
        height: 42px;
      }
    }
    .gameBox-17 {
      position: absolute;
      top: 56%;
      left: 50%;
      margin-left: -150px;
      margin-bottom: -21px;
      img {
        width: 300px;
        height: 42px;
      }
    }
    .gameBox-10 {
      position: absolute;
      top: 22%;
      left: 50%;
      margin-left: -120px;
      margin-bottom: -200px;
      img {
        width: 230px;
        height: 390px;
      }
    }
    .gameBox-13 {
      position: absolute;
      top: 22%;
      left: 50%;
      margin-left: -120px;
      margin-bottom: -10px;
      img {
        width: 220px;
        height: 400px;
      }
    }
    .gameBox-12 {
      position: absolute;
      top: 30%;
      left: 50%;
      margin-left: -140px;
      margin-bottom: -170px;
      img {
        width: 280px;
        height: 280px;
      }
    }
    .gameBox-14 {
      position: absolute;
      top: 30%;
      left: 50%;
      margin-left: -150px;
      margin-bottom: -110px;
      img {
        width: 300px;
        height: 220px;
      }
    }
    .gameBox-5 {
      position: absolute;
      top: 15%;
      left: 50%;
      margin-left: -160px;
      margin-bottom: -27.5px;
      img {
        width: 320px;
        height: 60px;
      }
    }
    .gameBox-6 {
      position: absolute;
      top: 30%;
      left: 50%;
      margin-left: -160px;
      margin-bottom: -35px;
      img {
        width: 320px;
        height: 70px;
      }
    }
    .gameBox-7 {
      position: absolute;
      top: 45%;
      left: 50%;
      margin-left: -160px;
      margin-bottom: -32.5px;
      img {
        width: 320px;
        height: 65px;
      }
    }
    .gameBox-11 {
      position: absolute;
      top: 62%;
      left: 50%;
      margin-left: -150px;
      margin-bottom: -25px;
      img {
        width: 300px;
        height: 110px;
      }
    }
    .gameBox-app {
      position: absolute;
      bottom: 12%;
      left: 50%;
      margin-left: -80px;
      margin-bottom: -30px;
      img {
        width: 160px;
        height: 60px;
      }
    }
    .gameBox-wx {
      position: absolute;
      bottom: 15%;
      left: 50%;
      margin-left: -70px;
      margin-bottom: -27.5px;
      img {
        width: 140px;
        height: 55px;
      }
    }

    
    .wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      font-size: 0;
      z-index: 9999;
    }

    .block {
      font-size: 0;
      text-align: center;
      .msgbox {
        width: 3rem;
        padding: 0.2rem 0 0.14rem;
        background-color: #fff;
        border-radius: 0.1rem;
        h3 {
          text-align: center;
          font-size: 0.15rem;
          font-weight: bold;
          padding-bottom: 0.2rem;
        }
        p {
          padding-bottom: 0.2rem;
          height: 0.2rem;
          line-height: 0.2rem;
          text-align: center;
          font-size: 0.14rem;
          color: #333;
          font-weight: 400;
        }
        .openapp-button {
          display: inline-block;
          width: 2.3rem;
          height: 0.54rem;
          img {
            width: 100%;
          }
        }
      }
      .old-close {
        display: inline-block;
        margin-top: 0.2rem;
        width: 0.35rem;
        height: 0.35rem;
        img {
          width: 0.35rem;
          height: 0.35rem;
        }
      }
    }

    .wx-back {
      position: fixed;
      top: 10px;
      right: 20px;
      img {
        width: 175px;
        height: 120px;
      }
    }

    .msgbox-botton {
      position: relative;
      display: inline-block;
      width: 80%;
      height: 0.45rem;
      background: linear-gradient(294deg,#127be4 15%, #00a4ff 97%);
      border-radius: 0.04rem;
      font-size: 0.15rem;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: 500;
      text-align: center;
      color: #ffffff;
      line-height: 0.45rem;
      strong {
        margin-left: 0.2rem;
      }
      .launch-btn {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 1;
        opacity: 0;
      }
    }
  }
  
</style>